export const sessionCookieName = "__Host-lys_session";
export const csrfCookieName = "__Host-lys_csrf";

export const authMethods = ["password", "passkey", "oidc", "bootstrap"] as const;
export type AuthMethod = (typeof authMethods)[number];

export function isAuthMethod(value: unknown): value is AuthMethod {
  return typeof value === "string" && authMethods.some((method) => method === value);
}

export function isUnsafeHttpMethod(method: string): boolean {
  const normalized = method.toUpperCase();
  return normalized !== "GET" && normalized !== "HEAD" && normalized !== "OPTIONS";
}

export function parseCookieHeader(header: string | null): ReadonlyMap<string, string> {
  const cookies = new Map<string, string>();
  if (!header) return cookies;

  for (const part of header.split(";")) {
    const separator = part.indexOf("=");
    if (separator <= 0) continue;
    const name = part.slice(0, separator).trim();
    const value = part.slice(separator + 1).trim();
    if (name && !cookies.has(name)) cookies.set(name, value);
  }
  return cookies;
}

export function isSessionTokenShape(value: unknown): value is string {
  return typeof value === "string" && /^[A-Za-z0-9_-]{43}$/.test(value);
}
